/**
 * Глубокое клонирование объектов
 * Замена structuredClone() для совместимости со старыми браузерами
 * (Safari < 15.4, Chrome < 98)
 */

/**
 * Создаёт глубокую копию объекта
 * @param obj - объект для клонирования
 * @returns глубокая копия объекта
 */
export const deepClone = <T>(obj: T): T => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  try {
    return JSON.parse(JSON.stringify(obj));
  } catch {
    // Если JSON.parse/stringify не работает, возвращаем исходный объект
    return obj;
  }
};
